/**
 * Redirect Href Directive
 * Used to ensure an anchor tag functions as an anchor tag and not ui route
 * Todo use anchor tag correctly so this doesn't need to exist
 *
 */

function redirectHref() {
    return {
        restrict: 'A',
        scope: {'onChange':'=' },
        link: function(scope, element, attrs, ctrl)
        {
            element.on("click",function($event) {
                $event.preventDefault();
                location.href = attrs.redirectHref;
            });
        }
    };
}
export default angular.module('redirectHref', []).directive('redirectHref', redirectHref).name;


/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/directives/redirectHref.directive.js
 **/